import { UserRole, type UserRole as UserRoleType } from "@edlab-fms/shared";

export interface NavItem {
  to: string;
  label: string;
  end?: boolean;
  badge?: number;
}

const ALL_NAV: NavItem[] = [
  { to: "/", label: "Overview", end: true },
  { to: "/transactions", label: "Transactions" },
  { to: "/programmes", label: "Programmes" },
  { to: "/donors", label: "Donors" },
  { to: "/scholarships", label: "Scholarships" },
  { to: "/reports", label: "Reports" },
  { to: "/settings", label: "Settings" },
];

export function navItemsForRole(role: UserRoleType, _unitIds: string[]): NavItem[] {
  switch (role) {
    case UserRole.DONOR:
      return [{ to: "/funding", label: "My funding", end: true }];
    case UserRole.BOARD_MEMBER:
    case UserRole.PROJECT_LEAD:
      return ALL_NAV.filter((item) =>
        ["/", "/programmes", "/reports"].includes(item.to),
      );
    case UserRole.AUDITOR:
      return ALL_NAV.filter((item) =>
        ["/", "/transactions", "/programmes", "/reports", "/settings"].includes(item.to),
      );
    case UserRole.FINANCE_REVIEWER:
      return ALL_NAV.filter((item) => item.to !== "/settings");
    case UserRole.SUPER_ADMIN:
      return ALL_NAV;
    case UserRole.ACCOUNTS:
      return ALL_NAV.filter((item) => item.to !== "/settings");
    default:
      return ALL_NAV.filter((item) => item.to !== "/settings");
  }
}

export function routeAllowedForRole(
  pathname: string,
  role: UserRoleType,
  unitIds: string[],
): boolean {
  const allowed = navItemsForRole(role, unitIds);
  const base = pathname === "/" ? "/" : `/${pathname.split("/").filter(Boolean)[0] ?? ""}`;

  if (role === UserRole.DONOR) {
    return base === "/funding";
  }

  return allowed.some((item) => item.to === base);
}

export function breadcrumbForPath(pathname: string): string {
  const segment = pathname.split("/").filter(Boolean)[0];
  const labels: Record<string, string> = {
    "": "Overview",
    transactions: "Transactions",
    programmes: "Programmes",
    funding: "My funding",
    donors: "Donors",
    scholarships: "Scholarships",
    reports: "Reports",
    settings: "Settings",
  };
  return labels[segment ?? ""] ?? "Workspace";
}
